<template>
    <div class="m-calendar__timelist" v-if="cells.length">
        <calendar-modal-cell :cell="cell" v-for="cell in cells" :key="cell.start_at.format('YYYY-MM-DD HH:mm')"></calendar-modal-cell>
        <!--<div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">10:30</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">11:00</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">11:30</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">10:00</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button m-calendar__button_selected r-button">10:30</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">11:00</button>
        </div>
        <div class="m-calendar__group">
            <button class="m-calendar__button r-button" type="button">11:30</button>
        </div>-->
    </div>
</template>

<script>
	import {mapGetters} from 'vuex';

	import CalendarModalCell from "./CalendarMobileCell.vue";

	export default {
		components: {CalendarModalCell},
		name: 'CalendarMobileCells',
		computed: {
			...mapGetters({
				cells: 'filterCells',
			}),
		},
        mounted() {
			setTimeout(() => console.log(this.cells), 1000);
        }
    }
</script>
